import colors from '../../theme/colors';
import Icon, { IconProps } from '../Icon/Icon';
import React from 'react';
import { Flex } from 'rebass';

type ReactSelectButtonProps = Partial<IconProps> & {
  onClick: () => void;
};

const ReactSelectButton: React.FC<ReactSelectButtonProps> = (props) => (
  <Flex
    onClick={(e) => {
      props.onClick?.();
      e.stopPropagation();
      e.preventDefault();
    }}
    onMouseDown={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}
    type="button"
    title={props.title}
    sx={{
      justifyContent: 'center',
      padding: '8px',
    }}
  >
    <Icon
      size="18px"
      style={{
        color: colors.primary,
        pointerEvents: 'none',
        ...props.style,
      }}
      icon="plus-circle"
      {...props}
    />
  </Flex>
);

export default ReactSelectButton;
